module.exports = __webpack_public_path__ + "img/numer_konta.5f6bb6af.png";